import React from 'react';
import PageLayout from '../components/PageLayout';

const ShippingDeliveryPage = () => {
  return (
    <PageLayout title="Shipping and Delivery">
      <p>
        Curators' Studio currently offers flower subscription services
        exclusively in Gurugram, Haryana, India. We are committed to providing
        fresh, premium-quality flowers, which is why we maintain this focused
        delivery area to ensure optimal freshness.
      </p>

      <h3>Delivery Schedule</h3>
      <p>
        Depending on your subscription plan, deliveries will be made once,
        twice, or thrice weekly. Our standard delivery hours are between 8:00 AM
        and 7:00 PM. While we cannot guarantee specific delivery times within
        this window, we strive to maintain consistency in our delivery schedule.
      </p>

      <h3>Delivery Process</h3>
      <p>
        Our flowers are hand-delivered by our specialized delivery personnel.
        Each arrangement is carefully transported to minimize damage and
        maximize freshness. Our delivery team will leave the flowers at your
        doorstep if you're not available to receive them in person.
      </p>

      <h3>Special Handling</h3>
      <p>
        All our flower arrangements are packaged with care to preserve their
        quality during transit. We use eco-friendly packaging materials that
        protect the flowers while minimizing environmental impact.
      </p>

      <h3>Delivery Fees</h3>
      <p>
        Delivery fees are included in your subscription price. There are no
        additional charges for standard delivery within our service area.
      </p>

      <h3>Missed Deliveries</h3>
      <p>
        If you're not home during delivery, our delivery personnel will leave
        your flowers at your doorstep or with your building's reception/security
        as specified in your delivery instructions. If delivery cannot be
        completed due to access issues or other complications, we will contact
        you to reschedule.
      </p>

      <h3>Delivery Instructions</h3>
      <p>
        You can provide specific delivery instructions during the subscription
        sign-up process. If you need to update these instructions for future
        deliveries, please contact our customer service at least 24 hours before
        your scheduled delivery.
      </p>

      <h3>Quality Guarantee</h3>
      <p>
        We guarantee the quality of our flowers upon delivery. If you're not
        satisfied with the condition of your flowers at the time of delivery,
        please contact us within 24 hours with photos, and we'll arrange for a
        replacement at no additional cost.
      </p>
    </PageLayout>
  );
};

export default ShippingDeliveryPage;
